import React from 'react';
import { Pressable, View, Text, StyleProp, TextStyle } from 'react-native';

import defaultStyle, { buttonHitSlop } from './tabBar.jss';

interface ButtonComponentProps {
    onPress: () => void;
    onLongPress: () => void;
    testID: string;
    accessibilityLabel?: string;
    label: string;
    labelStyle: StyleProp<TextStyle>;
    stripColor: string;
}

const TabBarButton = ({
    onPress,
    onLongPress,
    testID,
    accessibilityLabel,
    label,
    labelStyle,
    stripColor
}: ButtonComponentProps): JSX.Element => (
    <Pressable
        onPress={onPress}
        onLongPress={onLongPress}
        testID={testID}
        hitSlop={buttonHitSlop}
        accessibilityLabel={accessibilityLabel}
        style={defaultStyle.buttonComponent}
    >
        <Text style={labelStyle}>{label}</Text>
        <View style={[defaultStyle.buttonStrip, { backgroundColor: stripColor }]} />
    </Pressable>
);

export default TabBarButton;
